// todo: use basic concepts 'connection' and 'shape'
// todo: type of element only in businessModel
import {computeMsgId} from '@angular/compiler/src/i18n/digest';

export class Connection {

  // public type = 'undefined';
  public fromPsycotype = null;
  public toPsychotype = null;
  public id;
  public description = '';

  // a lot of flows or connections are possible between two psychotypes and all
  // connections should be visible. solution: move it to random value from the center
  private dx: number = 0;
  private dy: number =0;

  /**
   * colors are in use to mark connection type
   *
   * ua.ahm1 - red, uk.ahm1 - yellow, um.ahm1 - blue
   * ra.ahm1 - green, rk.ahm1 - yellow, rm.ahm1 - blue
   */
  private color = 'red';

  constructor(private ctx: CanvasRenderingContext2D, private psy1, private psy2, public type = 'undefined', public descr ='', public group = 0) {
    this.fromPsycotype = psy1;
    this.toPsychotype = psy2;
    this.id = 'connection_' + this.makeid(10);// new Date().getTime();
    // console.log();
    this.description = descr;

    let z: number = 33;
    // if (this.fromPsycotype.z < this.toPsychotype) {
    //   z = this.fromPsycotype.z;
    // } else {
    //   z = this.toPsychotype.z;
    // }

    // generate random shift -15..+15 from figure center
    this.dx = Math.floor(Math.random() * z) + 1 - (z / 2);
    this.dy = Math.floor(Math.random() * z) + 1 - (z / 2);

    // find out connection type and mark it with according color from specification
    switch(type) {
      case 'ua.ahm1': {
        this.color = 'red';
        break;
      }
      case 'uk.ahm1': {
        this.color = 'yellow';
        break;
      }
      case 'um.ahm1': {
        this.color = 'blue';
        break;
      }
      case 'ra.ahm1': {
        this.color = 'green';
        break;
      }
      case 'rk.ahm1': {
        this.color = 'yellow';
        break;
      }
      case 'rm.ahm1': {
        this.color = 'blue';
        break;
      }
      default: {
        // do nothing
        break;
      }
    }

    // console.log('connection created', this.id, psy1.name, psy2.name, type, this.color, this.description, this.group);
  }

  makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  draw() {

    let startX: number, startY: number, midX: number, midY: number, endX: number, endY: number;

    startX = this.fromPsycotype.x + this.fromPsycotype.z / 2 + this.dx;
    startY = this.fromPsycotype.y + this.fromPsycotype.z / 2 + this.dy;
    endX = this.toPsychotype.x + this.fromPsycotype.z / 2 + this.dx;
    endY = this.toPsychotype.y + this.fromPsycotype.z / 2 + this.dy;
    midX = (startX + endX) / 2;
    midY = (startY + endY) / 2;

    this.ctx.beginPath();
    this.ctx.strokeStyle = this.color; //'red';
    this.ctx.lineWidth = 2;
    // this.ctx.moveTo(this.fromPsycotype.x + this.fromPsycotype.z / 2, this.fromPsycotype.y + this.fromPsycotype.z / 2);
    // this.ctx.lineTo(this.toPsychotype.x + this.fromPsycotype.z / 2, this.toPsychotype.y + this.fromPsycotype.z / 2);
    // first part of line before middle
    this.arrow(
        this.ctx,
        startX,
        startY,
        midX,
        midY
        );
    // second part of line after middle
    this.arrow(
        this.ctx,
        midX,
        midY,
        endX,
        endY
    );
    this.setGroupNumber(midX, midY);
    this.ctx.stroke();
  }

  setGroupNumber(x, y) {
    if (0 != this.group) {
      this.ctx.fillStyle = this.color;
      this.ctx.font = "bold italic 10pt Arial";
      this.ctx.fillText(this.group + '', x, y + 15);
    }
  }

  /**
   * save object state into String
   */
  serialization() {
    return ';connection,' +
        this.psy1.id + ',' +
        this.psy2.id + ',' +
        this.type    + ',' +
        this.description + ',' +
        this.group +
        ';';
  }

  /**
   * Draw arrow instead of line
   *
   * @param context
   * @param fromx
   * @param fromy
   * @param tox
   * @param toy
   */
  arrow(context, fromx, fromy, tox, toy) {
    var headlen = 10; // length of head in pixels
    var dx = tox - fromx;
    var dy = toy - fromy;
    var angle = Math.atan2(dy, dx);
    context.moveTo(fromx, fromy);
    context.lineTo(tox, toy);
    context.lineTo(tox - headlen * Math.cos(angle - Math.PI / 6), toy - headlen * Math.sin(angle - Math.PI / 6));
    context.moveTo(tox, toy);
    context.lineTo(tox - headlen * Math.cos(angle + Math.PI / 6), toy - headlen * Math.sin(angle + Math.PI / 6));
  }

}
